import { type MoneyV2 } from '@shopify/hydrogen-react/storefront-api-types';

export const formatMoneyV2 = ({ amount }: { amount: MoneyV2 }) => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: amount.currencyCode,
  }).format(Number.parseFloat(amount.amount));
};
